<template>
  <div>
    <d-row no-gutters>
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img class="auth-form__logo d-table mx-auto mb-3" src="@/assets/images/logos/logo-s.png" />
            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">Entre com sua conta Microsoft</h5>
            <div>
              <!-- Form Fields -->
              <d-form>
                <ValidationObserver ref="validationForm">
                  <!-- Email -->
                  <!-- <d-form-row>
                    <d-col md="12" class="form-group">
                      <ValidationProvider
                        rules="required|email"
                        v-slot="{ errors, invalid }"
                      >
                        <b-input
                          :class="[fading, IsInvalidForm(invalid)]"
                          v-model="login.Email"
                          :disabled="loading"
                          type="email"
                          placeholder="E-mail"
                        />
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row> -->

                  <!-- Password -->
                  <!-- <d-form-row>
                    <d-col md="12" class="form-group">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors, invalid }"
                      >
                        <b-input
                          :class="[fading, IsInvalidForm(invalid)]"
                          ref="passwordField"
                          v-model="login.Password"
                          :disabled="loading"
                          @keyup.enter="AuthenticateValidation($event)"
                          type="password"
                          placeholder="Senha"
                        />
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row> -->

                </ValidationObserver>
                <ValidationObserver ref="validationFormPostResponse">
                  <ValidationProvider rules="min:1" vid="User" v-slot="{ errors }">
                    <input type="text" v-model="User" hidden />
                    <div class="invalid-feedback d-block text-center mb-4" v-if="validatedFormPost">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </ValidationObserver>
                <!-- <div class="form-group mb-3 d-table mx-auto">
                  <d-checkbox value="remember">Lembrar meus dados</d-checkbox>
                </div> -->
                <b-button pill v-on:click.stop="AuthenticateValidation($event)" class="btn-accent d-table mx-auto"
                  :disabled="loading">
                  <template v-if="!loading">ENTRAR</template>
                  <template v-else>
                    <b-spinner small v-if="loading"></b-spinner>
                  </template>
                </b-button>
              </d-form>
            </div>
          </d-card-body>
        </d-card>
        <!-- Meta Details -->
        <!-- <div class="auth-form__meta d-flex mt-4">
          <d-link tag="a" to="forgot-password" class="mx-auto"
            >Esqueceu sua senha?</d-link
          >
        </div> -->
      </d-col>
    </d-row>
  </div>
</template>
<script>
const Fingerprint2 = require("fingerprintjs2");

import { loginAzureAd, getTokenAzureAd, msalInstance } from "@/utils/authConfig";


export default {
  name: "login",
  data: function () {
    return {
      loading: false,
      validatedForm: false,
      fading: null,
      validatedFormPost: false,
      login: {
        Email: null,
        Password: null,
      },
    };
  },
  computed: {
    User() {
      return this.login.Email;
    },
    Fade() {
      return this.fading;
    },
  },
  mounted() {
    var auth = this.$getAuth();
    if (auth != null) {
      this.$router.push({ name: "access-quick" });
    }
    sessionStorage.setItem("NotificationIsReaded", false);

    let autologout = sessionStorage.getItem("sessionExpired");
    sessionStorage.removeItem("sessionExpired");

    if (autologout) autologout = "sessionExpired";

    let error = this.$route.query.error;
    let info = this.$route.query.info;
    if (error || info || autologout) {
      let identificator = error ? error : info ? info : autologout;
      let msg = null;
      switch (identificator) {
        case "credentialsNeeded":
          msg = "Você precisa se autenticar para acessar esse recurso.";
          break;
        case "sessionExpired":
          msg = "Sua sessão expirou, faça login novamente para continuar.";
          break;
        case "sessionFinished":
          msg = "Você foi desconectado com sucesso!";
          break;
        case "unauthorized":
          msg = "Você não possui permissão para acessar esse recurso.";
          break;
      }
      if (msg) this.$makeToast(msg, "info", "");
    }

    const email = this.$route.query.email;
    if (email) {
      this.login.Email = email;
      this.$refs.passwordField.$el.focus();
    }
  },
  methods: {
    IsInvalidForm: function (invalid) {
      return this.$options.filters.showValidateError(
        this.validatedForm,
        invalid
      );
    },
    AuthenticateValidation: function (e) {
      e.preventDefault();
      this.validatedForm = true;
      this.$refs.validationForm.validate().then((valid) => {
        if (valid) {
          this.Authenticate();
          this.validatedForm = false;
        }
      });
    },
    Authenticate: async function () {
      this.loading = true;
      this.validatedFormPost = false;

      const resposta = await loginAzureAd();
      if (resposta && resposta.account) {
        this.usuario = resposta.account.name;
      }

      const token = await getTokenAzureAd();

      if (token == null) {
        this.$makeToast(
          "Erro ao autenticar o usuário",
          "danger",
          "Não foi possível buscar o Token no AD.",
        );
        this.loading = false;
        return;
      }

      this.login.token = token;

      this.$store
        .dispatch("Authenticate", this.login)
        .then((response) => {
          // requestIdleCallback(() => {
          Fingerprint2.getV18((result) => {
            this.$setFingerprint(result);
          });
          // });
          this.$setAuth(response);
          const nextUrl = sessionStorage.getItem("nextUrl");
          sessionStorage.removeItem("nextUrl");

          if (nextUrl) {
            window.location.href = nextUrl;
          } else this.$router.push({ name: "access-quick" });
        })
        .catch((error) => {
          if (error.showToast) {
            this.$makeToast(
              "Erro ao autenticar o usuário - " + error.response.status,
              "danger",
              error.response.statusText,
            );
          } else if (error.ErrorCode == "069") {
            this.fading = "boxShadowAnim";
            setTimeout(() => {
              this.fading = null;
            }, 3000);

            this.validatedFormPost = true;
            this.$refs.validationFormPostResponse.setErrors({
              User: ["Usuário inválido!"],
            });
          } else {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao autenticar o usuário",
              error
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.boxShadowAnim {
  -webkit-animation: animFunc 2s; /* Safari 4.0 - 8.0 */
  animation: animFunc 2s;
}

@-webkit-keyframes animFunc {
  50% {
    box-shadow: 0px 0px 2px 2px rgba(255, 0, 43, 1);
  }
}

@keyframes animFunc {
  50% {
    box-shadow: 0px 0px 2px 2px rgba(255, 0, 43, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login.vue